
import { Carousel } from 'flowbite-react';

export default function OnboardingCarousel() {
  return (
    <Carousel
    theme={{
        item: {
            base: 'absolute top-1/2 left-1/2 block w-full -translate-x-1/2 -translate-y-1/2',
            wrapper: 'w-full flex-shrink-0 transform cursor-grab snap-center',
          }
    }}
    >
        <div className="flex  h-[98vh] rounded-lg items-center justify-center bg-gray-400 dark:bg-gray-700 dark:text-white">
            <img className="w-full " alt="" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/image+1.png" /> 
        </div>
        <div className="flex  h-[98vh] rounded-lg items-center justify-center bg-gray-400 dark:bg-gray-700 dark:text-white">
            <img className="w-full " alt="" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/image2.png" /> 
        </div>
        <div className="flex h-[98vh] rounded-lg items-center justify-center bg-gray-400 dark:bg-gray-700 dark:text-white">
            <img className="w-full " alt="" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/image3.png" /> 
        </div>
    </Carousel>
  )
}

